import React from 'react';
import { Form, Input } from 'semantic-ui-react';

import { Rut } from 'src/modulos/Cobranzas/RutPasaporte';

interface PagoChequeProps {
    numeroDeCheque: string;
    idInstitucionCheque: string;
    numeroDeCuentaCheque: string;
    nombreTitularCheque: string;
    rutTitularCheque: string;
    fechaCheque: string;
    esDeTercerosCheque: boolean;

    nombreCompletoApoderado: string;
    rutPasaporteApoderado: string;

    alCambiarCampo(nombreDelCampo: string, valor: string | boolean): void;
}
// TODO: instituciones agregadas a mano. Hay que sacarlas del mismo lado de matriculas

const PagoCheque: React.FunctionComponent<PagoChequeProps> = props => {
    const {
        numeroDeCheque,
        idInstitucionCheque,
        nombreTitularCheque,
        rutTitularCheque,
        fechaCheque,
        esDeTercerosCheque,
        alCambiarCampo,

        nombreCompletoApoderado,
    } = props;

    return (
        <div>
            <Form.Select
                width={6}
                required
                value={idInstitucionCheque}
                label='Institución'
                placeholder='Seleccione'
                options={[
                    { value: 'bbva', text: 'BANCO BBVA' },
                    { value: 'bci', text: 'BANCO BCI-TBANK-NOVA' },
                    { value: 'bice', text: 'BANCO BICE' },
                    { value: 'btg', text: 'BANCO BTG PACTUAL CHILE' },
                    { value: 'consorcio', text: 'BANCO CONSORCIO' },
                    { value: 'corpbanca', text: 'BANCO CORPBANCA' },
                    { value: 'edwards', text: 'BANCO DE CHILE/EDWARDS CITYBANK' },
                    { value: 'estado', text: 'BANCO ESTADO' },
                    { value: 'falabella', text: 'BANCO FALABELLA' },
                    { value: 'hsbc', text: 'BANCO HSBC BANK CHILE' },
                    { value: 'itau', text: 'BANCO ITAU' },
                    { value: 'internacional', text: 'BANCO INTERNACIONAL' },
                    { value: 'paris', text: 'BANCO PARIS' },
                    { value: 'penta', text: 'BANCO PENTA' },
                    { value: 'rabobank', text: 'BANCO RABOBANK CHILE (EX HNS BANCO)' },
                    { value: 'ripley', text: 'BANCO RIPLEY' },
                    { value: 'santander', text: 'BANCO SANTANDER BANEFE' },
                    { value: 'scotiabank', text: 'BANCO SCOTIABANK/DESARROLLO' },
                    { value: 'security', text: 'BANCO SECURITY' },
                ]}
                onChange={(_e, { value }) => {
                    alCambiarCampo('idInstitucionCheque', value as string);
                }}
            />
            <Form.Input
                label='Número de serie'
                placeholder='123456789'
                required
                value={numeroDeCheque}
                width={6}
                onChange={(_e, { value }) => {
                    alCambiarCampo('numeroDeCheque', value);
                }}
            />
            <Form.Input
                type='date'
                label='Fecha del cheque'
                required
                width={6}
                value={fechaCheque}
                onChange={(_e, { value }) => {
                    alCambiarCampo('fechaCheque', value);
                }}
            />
            <Form.Checkbox
                label='Es de terceros'
                checked={esDeTercerosCheque}
                onChange={(_e, { checked }) => {
                    alCambiarCampo('esDeTercerosCheque', checked!);
                }}
            />
            <Form.Field width={6} required>
                <label>Rut</label>
                <Rut
                    rut={rutTitularCheque}
                    readOnly={!esDeTercerosCheque}
                    disabled={!esDeTercerosCheque}
                    alCambiarRut={rut => alCambiarCampo('rutTitularCheque', rut)}
                    esValido={value => alCambiarCampo('rutEsValido', value)}
                />
            </Form.Field>
            <Form.Field required width={6}>
                <label>Nombre del titular</label>
                <Input
                    placeholder='Esmerildo Casimiro Perono'
                    value={!esDeTercerosCheque ? nombreCompletoApoderado : nombreTitularCheque}
                    readOnly={!esDeTercerosCheque}
                    disabled={!esDeTercerosCheque}
                    onChange={(_e, { value }) => {
                        alCambiarCampo('nombreTitularCheque', value);
                    }}
                />
            </Form.Field>
        </div>
    );
};

export default PagoCheque;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/PagoCheque.tsx